<div [formGroup]="form">
  <div class="flex flex-row rounded-md shadow-sm" role="group">
    <button
      *ngFor="let type of verificationTypes; index as i"
      type="button"
      class="flex-1 px-4 py-2 text-sm font-medium text-gray-500 border-gray-300 hover:bg-notus-primary-700 hover:text-white focus:z-10 focus:ring-2 focus:ring-notus-primary-300 focus:bg-notus-primary-700 focus:text-white dark:hover:text-white dark:hover:bg-primary-700 dark:focus:bg-primary-800"
      [class]="verificationButtonClasses(type, i)"
      (click)="form.controls.verification.patchValue(type)"
    >
      {{ type | translate }}
    </button>
  </div>

  <div class="py-2"></div>

  <div
    class="flex flex-row flex-nowrap items-stretch h-10 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-primary-600 focus:border-primary-600 w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
  >
    <ng-container #workerIdInput *ngIf="verifyWorkerId">
      <input
        type="text"
        name="workerId"
        id="worker-id"
        class="flex-grow px-2.5 border-none focus:outline-none focus:ring-0 bg-transparent"
        placeholder="{{ 'Worker ID' | translate }}"
        formControlName="workerId"
      />
    </ng-container>

    <ng-container #supplierIdInput *ngIf="verifySupplierId">
      <input
        type="text"
        name="supplierId"
        id="supplier-id"
        class="flex-grow px-2.5 border-none focus:outline-none focus:ring-0 bg-transparent"
        placeholder="{{ 'supplier id' | translate }}"
        formControlName="supplierId"
      />
    </ng-container>
  </div>

  <div *ngIf="recaptchaV2" class="mt-4 text-center">
    <re-captcha
      class="inline-block"
      (resolved)="onRecaptchaV2Resolve($event)"
    ></re-captcha>
  </div>

  <p
    class="mt-1 text-xs text-red-600 dark:text-red-500"
    *ngIf="
      form.controls.workerId?.errors &&
      (form.controls.workerId?.touched ?? false)
    "
    [translate]="'is required.'"
    [translateParams]="{ fieldname: 'Worker ID' | translate }"
  ></p>

  <button
    type="submit"
    class="mt-8 flex flex-row justify-center w-60 m-auto text-white focus:outline-none focus:ring-notus-primary-300 font-medium rounded-3xl text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
    (click)="onSubmit()"
    [class]="
      isLoading
        ? 'bg-white ring-notus-primary-700 ring-2 cursor-default'
        : 'bg-notus-primary-700 hover:bg-notus-primary-800'
    "
  >
    <ng-container *ngIf="!isLoading">
      {{ 'Next' | translate }}
    </ng-container>
    <ng-container *ngIf="isLoading">
      <flowbite-loading size="1.25rem"></flowbite-loading>
    </ng-container>
  </button>
</div>
